export enum UnitCardTabTypes {
  Rates = 'rates',
  Subscriptions = 'subscriptions',
  GeneralInfo = 'generalInfo',
  Battery = 'battery',
  Command = 'command',
  Locator = 'locator',
  UnitLog = 'unitLog',
  LatestPhotos = 'latestPhotos',
  LastOrder = 'lastOrder',
  Demand = 'demand',
  Groups = 'groups',
}

export type UnitCardTabType = typeof UnitCardTabTypes[keyof typeof UnitCardTabTypes];
